import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Terminal as TermIcon, X } from 'lucide-react';

export default function Terminal() {
  const [isOpen, setIsOpen] = useState(false);
  const [input, setInput] = useState('');
  const [logs, setLogs] = useState([
    'SYSTEM ONLINE...',
    'CONNECTION ESTABLISHED TO ALRAYA SECURE SERVER.',
    'TYPE "help" FOR AVAILABLE COMMANDS.'
  ]);

  useEffect(() => {
    let typed = '';
    const handleKeyDown = (e) => {
      if (isOpen) return;
      typed += e.key.toUpperCase();
      if (typed.length > 4) typed = typed.slice(-4);
      if (typed === 'HACK') {
        setIsOpen(true);
        typed = '';
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isOpen]);

  const handleCommand = (e) => {
    if (e.key === 'Enter') {
      const cmd = input.trim().toLowerCase();
      let response = '';
      
      if (cmd === 'help') response = 'COMMANDS: help, clear, discord, exit';
      else if (cmd === 'clear') { setLogs([]); setInput(''); return; }
      else if (cmd === 'discord') { response = 'REDIRECTING TO DISCORD...'; window.open('https://discord.gg/x5', '_blank'); }
      else if (cmd === 'exit') { setIsOpen(false); setInput(''); return; }
      else if (cmd !== '') response = `ERROR: UNKNOWN COMMAND "${cmd}"`;

      if (cmd !== '') {
        setLogs(prev => [...prev, `> ${cmd}`, response]);
      }
      setInput('');
    }
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 1.1 }}
          className="fixed inset-0 z-[9999] bg-black/90 backdrop-blur-xl flex items-center justify-center p-6"
        >
          <div className="w-full max-w-3xl bg-black border border-green-500/30 rounded-lg shadow-[0_0_30px_rgba(34,197,94,0.2)] overflow-hidden font-mono text-green-500 flex flex-col h-[60vh]">
            <div className="bg-green-500/10 p-3 flex justify-between items-center border-b border-green-500/30">
              <div className="flex items-center gap-2"><TermIcon size={18} /> ROOT@ALRAYA:~</div>
              <button onClick={() => setIsOpen(false)} className="hover:text-white"><X size={20} /></button>
            </div>
            <div className="p-6 flex-1 overflow-y-auto space-y-2">
              {logs.map((log, i) => <div key={i} className="opacity-90">{log}</div>)}
              <div className="flex gap-2 mt-4">
                <span>></span>
                <input
                  autoFocus
                  type="text"
                  value={input}
                  onChange={(e) => setInput(e.target.value)}
                  onKeyDown={handleCommand}
                  className="bg-transparent outline-none flex-1 text-green-500"
                />
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}